import { render, staticRenderFns } from "./FamilyCallCenterPane.vue?vue&type=template&id=ceb4c0c8&scoped=true&"
import script from "./FamilyCallCenterPane.vue?vue&type=script&lang=ts&"
export * from "./FamilyCallCenterPane.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyCallCenterPane.vue?vue&type=style&index=0&id=ceb4c0c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb4c0c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VIcon,VRow})
